<template>
    <component :is="componentType" v-model="isOpen" v-bind="$attrs">
        <div class="h-[85vh] md:h-[91vh] pt-[30px] overflow-y-auto backdrop-blur-sm bg-gray-50">
            <slot />
        </div>
    </component>
  </template>
  
  <script setup lang="ts">
  const { isMobile } = useDevice();
  const isOpen = defineModel();
  const componentType = computed(() => ('USlideover'));
  
  watch(isOpen, (open) => {
    if (open) {
      requestAnimationFrame(() => {
        const active = document.activeElement as HTMLElement | null
        if (active) {
          active.blur()
        }
      })
    }
  })
  </script>
  